export default __webpack_public_path__ + "81d7971a01d95186b497ac1c962fb542.svg";